import { z } from 'zod';
import type { SitemapPageToken } from '@sleed/bizcommerce-api';

/** Sitemap page edit form — legacy grid: code required ≤50, url required ≤150. */
export const sitemapPageSchema = z.object({
	id: z.number().optional(),
	code: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	url: z.string().trim().min(1, 'validation.required').max(150, 'validation.tooLong')
});

export type SitemapPageFormValues = z.infer<typeof sitemapPageSchema>;

export const EMPTY_SITEMAP_PAGE: SitemapPageFormValues = { code: '', url: '' };

export function tokenToForm(token: SitemapPageToken): SitemapPageFormValues {
	return { id: token.id, code: token.code ?? '', url: token.url ?? '' };
}

export function formToToken(form: SitemapPageFormValues): SitemapPageToken {
	return { id: form.id, code: form.code.trim(), url: form.url.trim() };
}
